/**
 *@author chenli
 *@description 密码框控件
 */


import Component from '../../../lib/component';
import './add-enrypt.html';
import template from './encrypt-input-control.html'
import WXtemplate from './encrypt-input-controL.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';

let config = {
    template: template,
    actions: {
        hasChangeValue(data) {
            let _this = this;
            this.data = _.defaultsDeep({}, data);
			this.el.find('.dynamic-form-input').val(data.value);
            _.debounce(function () {
                _this.events.changeValue(_this.data);
            }, 200)();
        }
    },
    binds: [
        {
            event: 'click',
            selector: '#edit',
            callback: function () {
                this.events.addPassword(this.data)
            }
        }
    ],
    afterRender() {
		this.el.find('.dynamic-form-input').val(this.data.value);
        this.el.find('.ui-width').css('width', this.data.width);
        if(this.data.history){
            this.el.find('.ui-history').css('visibility','visible');
        }
        if (this.data.is_view) {
            // this.el.find('.ui-width').attr('disabled', true);
			this.el.find('#edit').hide();
        } else {
            // this.el.find('.ui-width').attr('disabled', false);
        }
    },
    beforeDestory() {
        this.el.off();
    }
}
let PasswordControl = Component.extend(config)
export default PasswordControl

let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		hasChangeValue(data) {
			this.data = _.defaultsDeep({}, data);
			this.el.find('.dynamic-form-input').val(data.value);
		}
	}),
	binds:config.binds,
	afterRender() {
		this._super.afterRender();
	},

}
let PasswordWX=BaseControl.extend(WXconfig);
export {PasswordWX}


// WEBPACK FOOTER //
// app/components/form/encrypt-input-control/encrypt-input-control.js